<template>
	<div class="page container">
		<v2-back-btn :route="`/admin/deal-packs/${getDealPackId}`" />

		<div class="page__info">
			<div class="page__info--title">
				Students
			</div>
		</div>

		<div>
			<table-view
				:table="getTable"
				:pagination="pagination"
				:totalItems="totalItems"
				@search="onSearch"
				@paginate="onPaginate"
			/>
		</div>
	</div>
</template>

<script>
	import TableView     from '@/components/ui/views/tableView/TableView';
	import api           from '@/services/api';
	import dayjs         from 'dayjs';
	import relativeTime  from 'dayjs/plugin/relativeTime';
	import routeParams   from '@/mixins/routeParams';
	import V2BackBtn from '@/components/v2/ui/V2BackBtn';

	dayjs.extend(relativeTime);

	export default {
		metaInfo: {
			title: 'Students'
		},

		layout: 'v2default',

		components: {
			TableView,
			V2BackBtn
		},
		mixins: [routeParams],
		data: () => ({
			dealPack: {},
			students: [],
			searchString: '',
			pagination: {
				perPage: 20,
				currentPage: 1,
				totalPages: 0
			},
			totalItems: 0
		}),
		computed: {
			getDealPackTitle () {
				return this.dealPack?.title || '';
			},
			getTable () {
				if (!this.getDealPackId) {
					return false;
				}
				return {
					headings: [
						'Name',
						'Joined',
						'Progress',
						'Deals'
					].filter(Boolean),
					rows: this.students.map((student) => {
						return {
							route: `/admin/deal-packs/${this.getDealPackId}/students/${student.id}`,
							columns: [
								this.getNameString(student),
								this.getJoinDateString(student),
								this.getProgress(student),
								this.getDealProgress(student)
							].filter(Boolean)
						};
					})
				};
			},
			getBreadcrumbs () {
				return [
					{
						path: '/admin',
						text: 'Admin'
					},
					{
						path: this.getDealPacksRoute,
						text: 'Deal Packs'
					},
					{
						path: this.getDealPackRoute,
						text: this.getDealPackTitle
					},
					{
						path: `${this.getDealPackRoute}/students`,
						text: 'Students'
					}
				];
			}
		},
		created: function () {
			this.loadContent();
		},
		methods: {
			onSearch (value) {
				this.searchString = value;
				this.setStudents();
			},
			onPaginate (value) {
				this.pagination.currentPage = value;
				this.setStudents();
			},
			getNameString (student) {
				if (!student) {
					return false;
				}
				return `${student.firstName} ${student.lastName}`;
			},
			getJoinDateString (student) {
				if (!student) {
					return false;
				}
				return dayjs().to(student.joinDate);
			},
			getProgress (student) {
				if (!student) {
					return false;
				}
				return (student.progress === null) ? 'Incomplete' :
					(student.progress) ? 'Successfully Completed' : 'Completed';
			},
			getDealProgress (student) {
				if (!student) {
					return false;
				}
				return `Completed ${student.dealProgress} of ${student.dealCount}`;
			},
			async loadContent () {
				try {
					await Promise.all([
						this.setStudents(),
						this.setDealPack()
					]);
				} catch {
					this.$store.commit('ui/showError');
					return;
				}
				this.formLoaded = true;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			},
			async setStudents () {
				const response = await api.admin.getStudentsByDealPackId({
					dealPackId: this.getDealPackId,
					include: 'metadata',
					searchString: this.searchString,
					per: this.pagination.perPage,
					page: this.pagination.currentPage
				});
				if (!response) {
					this.$store.commit('showError');
					return false;
				}
				this.totalItems = response.meta.totalItems;
				this.pagination.totalPages = response.meta.numPages;
				this.pagination.currentPage = response.meta.page;
				this.students = response.results;
			},
			async setDealPack () {
				const dealPack = await api.admin.getDealPackById({
					dealPackId: this.getDealPackId
				});
				if (!dealPack) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.dealPack = dealPack;
			}
		}
	};

</script>
